import React, { PureComponent } from "react";
import './Menu.css';
import Button from '../Button/Button.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons'
library.add(faUndoAlt);

class RestorePurchases extends PureComponent {
    render() {
        return (
            <div
                style={{
                    width: '100%',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        transform: 'scale(0.8)',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        activeBorderColor={'#fff'}
                        onClick={() => {
                            if (window.store) {
                                window.store.refresh();
                            }
                        }}
                    >
                        <FontAwesomeIcon className="ButtonIcon" icon="undo-alt" />
                        Restore Purchases
                    </Button>
                </div>
            </div>
        );
    }
}

export default RestorePurchases;
